import { useContext, useEffect, useState } from 'react'

import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { Portal } from '@tribeplatform/react-ui-kit/Portal'

import { CookieConsentPopUp } from './CookieConsentPopUp.js'
import { CookieConsentPreferencesModal } from './CookieConsentPreferencesModal.js'
import { CookieContext } from './CookieContext.js'
import { getCookieSettings } from './utils/cookie-settings.js'

export const CookieConsent = () => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(true)
  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false)

  const { shouldShowCookiePopup } = useContext(CookieContext)

  useEffect(() => {
    if (
      !isPopUpOpen &&
      !isPreferencesModalOpen &&
      !getCookieSettings()?.hasUserConsent
    ) {
      setIsPopUpOpen(true)
    }
  }, [isPopUpOpen, isPreferencesModalOpen])

  const onManagePreferences = () => {
    setIsPreferencesModalOpen(true)
    setIsPopUpOpen(false)
  }

  if (!shouldShowCookiePopup) {
    return null
  }

  return (
    <>
      {isPopUpOpen && (
        <Portal>
          <Container
            size="full"
            padding={{ size: 'md', disableOnMobile: true }}
            containerProps={{
              className: 'fixed inset-x-0 bottom-0',
            }}
          >
            <Container size="xl">
              <CookieConsentPopUp
                onManage={onManagePreferences}
                onClose={() => setIsPopUpOpen(false)}
              />
            </Container>
          </Container>
        </Portal>
      )}
      <CookieConsentPreferencesModal
        isOpen={isPreferencesModalOpen}
        onClose={() => setIsPreferencesModalOpen(false)}
      />
    </>
  )
}
